import React, { useContext, useEffect, useState } from "react";
import { context } from "./DeviceAlertSettings";
import Commonpagination from "../Tables/CommonPagination";
import { Checkbox, Col, Row } from "antd";
import CommonButton from "../Buttons/CommonButton";
import classes from "./Device.module.css";
import Commontooltip from "../CommonTooltip/Commontooltip";
import deleteimg from "../../Assests/Images/delete.png";
import { CheckUserType, getValidData } from "../../Shared/Methods";
import { useSelector } from "react-redux";
import Createdevicerelaymodal from "../../Modals/Device/CreateDeviceRelayModal";
import CommonNodataFound from "../CommonNodataFound";
import Commonpopover from "../CommonPopOver/Commonpopover";

function Relayalert() {
  const contextdata = useContext(context);
  const {
    data,
    Getlist,
    listData,
    DropDowns,
    Dropdown,
    DeleteItem,
    handleCancel,
  } = contextdata || {};
  const { RelayData } = listData;
  const { items, page, size, total_page, total_count } = RelayData;

  const [showmodal, setShowModal] = useState(false);

  const [pageSize, setpageSize] = useState(10);
  const { LoginData } = useSelector((state: any) => state.Auth);

  useEffect(() => {
    if (LoginData !== null) {
      if (Getlist) Getlist(1, 10, "2");
    }
  }, [LoginData]);

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    if (Getlist) Getlist(1, size, "2");
  };

  return (
    <>
      {showmodal ? (
        <Createdevicerelaymodal
          open={showmodal}
          closable={!showmodal}
          onCancel={() => {
            setShowModal(false);
            handleCancel && handleCancel();
          }}
          handleSuccess={() => {
            if (Getlist) Getlist(1, size, "2");
          }}
          DropDowns={DropDowns}
          item={data}
          Dropdown={Dropdown}
        />
      ) : null}

      <div
        className={`${classes.inlinecard} h-100`}
        style={{ border: " 1px solid #20a2a033" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <h5 style={{ margin: "0", color: "#000000", fontWeight: 600 }}>
            Relay
          </h5>

          {data?.access_type === 1 ? (
            <CommonButton
              name="Create"
              type="button"
              onClick={() => setShowModal(true)}
              // style={{ padding: "7px 10px", maxWidth: "96px", height: "32px" }}
              classname="alert_create_btn"
            />
          ) : null}
        </div>

        <div
          style={{ overflow: "auto", maxHeight: "200px" }}
          className="scroll_inner"
        >
          <Row gutter={[16, 16]} className="m-0">
            {items?.length > 0 ? (
              items?.map((ele: any) => {
                return (
                  <>
                    <Col xxl={12} lg={24} sm={24} xs={24}>
                      <div
                        className={` ${classes.device_alert_settings_container}`}
                      >
                        <div>
                          {/* <p style={{ fontWeight: 600 }}>
                            {ele?.relay_name} -{" "}
                            {ele?.relay_for === 1 ? "Parameter" : "Input Pin"}
                          </p> */}

                          <Commontooltip
                            children={
                              <p
                                style={{ fontWeight: 600 }}
                                className="cards_name_heading"
                              >
                                {ele?.relay_name} -{" "}
                                {ele?.relay_for === 1
                                  ? "Parameter"
                                  : "Input Pin"}
                              </p>
                            }
                            msg={`${ele?.relay_name} - ${
                              ele?.relay_for === 1 ? "Parameter" : "Input Pin"
                            }`}
                            placement="topLeft"
                          />

                          {data?.access_type === 1 ? (
                            <div>
                              <Commontooltip
                                children={
                                  <img
                                    src={deleteimg}
                                    alt="deleteimg"
                                    style={{ width: "18px", height: "18px" }}
                                    onClick={() =>
                                      DeleteItem({
                                        isView: true,
                                        item: ele,
                                        Itemname: "Relay",
                                        fortype: "2",
                                        page: page,
                                        size: size,
                                      })
                                    }
                                  />
                                }
                                msg="Delete"
                              />
                            </div>
                          ) : null}
                        </div>

                        {ele?.relay_for === 1 ? (
                          <p
                            style={{
                              fontWeight: 600,
                              color: "#000000d6",
                              fontSize: 15,
                              padding: "12px 12px 0",
                            }}
                          >
                            Parameter :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.5)",
                                fontSize: 15,
                              }}
                            >
                              {getValidData(ele?.parameter)}
                            </span>
                          </p>
                        ) : null}

                        {ele?.relay_for === 2 ? (
                          <p
                            style={{
                              fontWeight: 600,
                              color: "#000000d6",
                              fontSize: 15,
                              padding: "12px 12px 0",
                            }}
                          >
                            Input Pin :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.5)",
                                fontSize: 15,
                              }}
                            >
                              {getValidData(ele?.parameter)}
                            </span>
                          </p>
                        ) : null}

                        <div
                          style={{ paddingBottom: "3px", paddingTop: "3px" }}
                        >
                          {ele?.relay_for === 1 ? (
                            <div className="d-flex flex-column w-100">
                              <div className="d-flex justify-content-between align-items-end gap-2 gap-xxl-0">
                                <p className={classes.highthershold}>
                                  Thershold High :{" "}
                                  <span>
                                    {getValidData(ele?.thershold_high)}
                                  </span>
                                </p>
                                <p className={`${classes.lowthershold}`}>
                                  Thershold Low :{" "}
                                  <span>
                                    {getValidData(ele?.thershold_low)}
                                  </span>
                                </p>
                                {/* <p>
                                  High Action :{" "}
                                  <span>
                                    {getValidData(ele?.high_action) === 1
                                      ? "ON"
                                      : "OFF"}
                                  </span>
                                </p> */}

                                {/* <p>
                                  Action :{" "}
                                  <span>
                                    {getValidData(ele?.high_action) === 1
                                      ? "ON"
                                      : "OFF"}
                                  </span>
                                </p> */}
                              </div>
                              <div className="d-flex justify-content-between align-items-end">
                                <p>
                                  High Action :{" "}
                                  <span>
                                    {getValidData(ele?.high_action) === 1
                                      ? "ON"
                                      : "OFF"}
                                  </span>
                                </p>
                                <p>
                                  Low Action :{" "}
                                  <span>
                                    {getValidData(ele.low_action) === 1
                                      ? "ON"
                                      : "OFF"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ) : ele?.relay_for === 2 ? (
                            <>
                              <div className="d-flex flex-column">
                                <p>
                                  Pin Number :{" "}
                                  <span>{getValidData(ele?.pin_number)}</span>
                                </p>

                                <div className="thersholdStatus notificationSettings">
                                  {/* Thershold : */}
                                  <Checkbox
                                    // disabled
                                    onClick={(event) => event.preventDefault()}
                                    checked={
                                      ele.thershold_high === "1" ? true : false
                                    }
                                    style={{ marginTop: "10px" }}
                                    id="checkbosspan"
                                  >
                                    <p>High</p>
                                  </Checkbox>
                                  <Checkbox
                                    onClick={(event) => event.preventDefault()}
                                    // disabled
                                    checked={
                                      ele.thershold_low === "1" ? true : false
                                    }
                                    style={{ marginTop: "10px" }}
                                    id="checkbosspan"
                                  >
                                    <p>Low</p>
                                  </Checkbox>
                                </div>
                              </div>
                              {/* <p>
                                  Action :{" "}
                                  <span>
                                    {getValidData(ele.action) === 1
                                      ? "ON"
                                      : "OFF"}
                                  </span>
                                </p> */}
                            </>
                          ) : null}
                        </div>

                        <Commonpopover
                          children={
                            <>
                              <div
                                style={{
                                  padding: "0 12px 12px",
                                }}
                              >
                                <p
                                  className={classes.description}
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Description :{" "}
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "rgba(0, 0, 0, 0.5)",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {getValidData(ele?.description)}
                                  </span>
                                </p>
                              </div>
                            </>
                          }
                          content={getValidData(ele?.description)}
                          title="Description"
                          open={ele?.description ? true : false}
                        />
                      </div>
                    </Col>
                  </>
                );
              })
            ) : (
              <CommonNodataFound />
            )}
          </Row>
        </div>

        <Commonpagination
          onShowSizeChange={Changesize} ///call when page size click
          total={total_count}
          current={page}
          pageSize={size}
          onChange={(e, size) => {
            ///call when page number click
            if (size === pageSize) {
              if (Getlist) Getlist(1, size, "2");
            }
          }}
        />
      </div>
    </>
  );
}

export default Relayalert;
